<template>
  <div class="widget-settings-wrapper">
    <!--START: Loading State-->
    <div v-if="isLoading" class="loading-state">
      <p>Authenticating...</p>
    </div>
    <!--END: Loading State-->

    <!--START: Error State-->
    <div v-if="hasError" class="error-state">
      <h3>Authentication Failed</h3>
      <p>{{ errorMessage }}</p>
    </div>
    <!--END: Error State-->
  </div>
</template>

<script>
import { AuthService } from "@/services";

export default {
  name: "WidgetSettings",
  data() {
    return {
      isLoading: true,
      hasError: false,
      errorMessage: "",
    };
  },
  async created() {
    await this.validateSsoToken();
  },
  methods: {
    async validateSsoToken() {
      try {
        const ssoToken = this.$route.query.ssoToken;

        if (!ssoToken) {
          this.showError("No SSO token provided");
          return;
        }

        const response = await AuthService.ValidateSsoToken({ ssoToken });

        if (response.hasError) {
          this.showError(response.message);
          return;
        }

        // Store user and company in Vuex
        const { user, company } = response.data;
        this.$store.commit("updateUser", {
          user: user,
          loggedIn: true,
        });
        this.$store.commit("updateCompany", company);

        // Redirect to the dashboard
        this.$router.push({ path: "/ai-assistant/tickets" });
      } catch (err) {
        console.error("SSO validation failed:", err);
        this.showError("Something went wrong during authentication");
      }
    },

    showError(message) {
      this.isLoading = false;
      this.hasError = true;
      this.errorMessage = message;
    },
  },
};
</script>

<style scoped>
.widget-settings-wrapper {
  text-align: center;
  margin-top: 3rem;
  padding: 1rem;
}

.loading-state p {
  font-size: 1rem;
  color: #666;
}

.error-state h3 {
  color: #1e1e1e;
  margin-bottom: 0.5rem;
}

.error-state p {
  color: #666;
  font-size: 0.9rem;
}
</style>
